export default __webpack_public_path__ + "bf83618dec72cd5bb21c52cb97e15408.jpg";